// Promoção de Aniversário 21 anos.
// ⚠️ Manter em sincronia com functions/src/index.ts: valor, bônus e o limite
// de 1 compra por conta são decididos lá. Aqui é só o que a tela exibe.

export const PROMOCAO = {
  id: 'aniversario21',
  nome: 'Promoção de Aniversário 21 anos',
  valorCompra: 2500,
  valorCashback: 2500,
  valorTotal: 5000,
} as const;

// A Cervejaria aceita o saldo anterior, mas não o desta promoção. A regra é
// aplicada no servidor (functions/src/saldo.ts); aqui é só para o aviso do caixa.
export const UNIDADE_CERVEJARIA_ID = '2';

export const REGRAS_PROMOCAO: string[] = [
  'Valor único: pague R$ 2.500,00 e leve R$ 5.000,00 em Tugas Coins (100% de cashback).',
  'Limite de 1 compra por conta (e-mail cadastrado). Quem comprou em promoções anteriores também pode participar.',
  'Pagamento exclusivamente via PIX, pela plataforma.',
  'O saldo fica disponível para uso 48 horas após a confirmação do pagamento.',
  'Válido para consumo no local ou retirada e para evento na Cave.',
  'Não vale para delivery de chope e delivery de pizza.',
  'Promoção por tempo limitado.',
];
